module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl2-75.165e4172.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl2-75.png
// module id = 3302
// module chunks = 11